import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Grid,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  Button,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import BarChartPage from "./dashboard-utils/BarChartPage";
import ApplicationTable from "./dashboard-utils/ApplicationTable";
import SearchIcon from "@mui/icons-material/Search";
import ButtonWrapper from "../../../citizen/AVPForms/components/Button";
import RiskWiseDetails from "./dashboard-utils/RiskWIseDetails";
import ProgreesWithOfficer from "./dashboard-utils/ProgreesWithOfficer";
import DialogContentModal from "../../../../../../templates/ApplicationDetails/components/DialogContent";
import InProgressWithOfficerModal from "./dashboard-utils/InProgressWithOfficerModal";
import EmpLandUsePortal from "../../LandUseVerification&NOC/EmpLandUsePortal";
import EmployeeApplicationDetail from "../../../../../../obps/src/pages/employee/BpaApplicationDetails/indexForm";
import { Route, useHistory, useRouteMatch } from "react-router-dom";
import { useDebounce } from "../../../../../../engagement/src/hooks/useDebounce";
import LandUseApprovedSummary from "./dashboard-utils/LandUseApprovedSummary";

const DashboardPage = () => {
  const match = useRouteMatch("/application/:id/preview");
  const history = useHistory();

  const handleClose = () => {
    history.goBack();
  };

  const getFinancialYearStart = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const year =
      today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;

    return new Date(year, 3, 1); // 1 April
  };

  const addOneYear = (date) => {
    const d = new Date(date);
    d.setFullYear(d.getFullYear() + 1);
    return d;
  };

  const subtractOneYear = (date) => {
    const d = new Date(date);
    d.setFullYear(d.getFullYear() - 1);
    return d;
  };

  const [selectedStatus, setSelectedStatus] = useState(null);
  const [totalApplications, setTotalApplications] = useState(0);
  const [selectedApplicationType, setSelectedApplicationType] = useState(null);
  const [selectedAuthority, setSelectedAuthority] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showMs, setshowMs] = useState(false);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  const location1 = userDetails?.location1?.length > 1 ? userDetails?.location1?.concat(" Development Authority") : null;
  let userType = userDetails?.roles?.some((role) => role.code === "HRMS_ADMIN" || role.code === "SUPERUSER" || role.code === "EMPLOYEE_ADMIN") ? "Admin" : null;
  let isSuperAdmin = userDetails?.roles?.some((role) => role.code === "SUPERUSER" || role.code === "EMPLOYEE_ADMIN");
  const isAvpUser = userDetails?.tenantId === "up.avp";

  const [fromDate, setFromDate] = useState(getFinancialYearStart);

  const [toDate, setToDate] = useState(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [activeCard, setActiveCard] = useState(null); 
  const [selectedRisk, setSelectedRisk] = useState(null);
  const [expandedAccordion, setExpandedAccordion] = useState("chartPanel");
  const [showInProgressModal, setShowInProgressModal] = useState(false);
  const [showLandUseApprovedModal, setShowLandUseApprovedModal] = useState(false)

  const [filters, setFilters] = useState({
    department: "",
    applicationType: "",
    status: "",
    riskType: "",
    subStatus: "",
    duplicateStatus: "",
    createdBy: "",
    userDesignation: "",
    assigned: "",
  });
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const { data: { BPA: { DashboardAuthorityList } = {} } = {}, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", [
    "DashboardAuthorityList",
  ]);

  useEffect(() => {
    if (isAvpUser && userType !== "Admin") {
      setSelectedAuthority("Uttar Pradesh Awas and Evam Vikas Parishad");
      setFilters((prev) => ({ ...prev, authority: "Uttar Pradesh Awas and Evam Vikas Parishad" }));
    } else if (location1 && userType !== "Admin") {
      setSelectedAuthority(location1);
      setFilters((prev) => ({ ...prev, authority: location1 }));
    }
  }, [location1, userType]);

  const [dashboardData, setDashboardData] = useState([]);
  const [fullData, setFullData] = useState([]);
  const [riskData, setRiskData] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [users, setUsers] = useState([]);
  const [fastPasIdSearch, setFastPasIdSearch] = useState("");

  const debounceFastPasIdSearch = useDebounce(fastPasIdSearch, 700);

  console.log("dashboardData", dashboardData);

  const applicationTypes = [
    { code: "ALL", name: "All Applications" },
    { code: "FORM_MAP", name: "Map Submission" },
    { code: "FORM_FAR", name: "FAR Application" },
    { code: "FORM_LANDUSE", name: "Land Use Application" },
    { code: "FORM_COMPLETION", name: "Completion Certificate" },
    { code: "FORM_PURCHASABLE_FAR", name: "Purchasable FAR" },
    { code: "FORM_PLINTH", name: "Plinth Inspection" },
    { code: "FORM_COMPOUNDING", name: "Compounding " },
    { code: "FORM_LANDUSECONVERSION", name: "Land Use Conversion" },
  ];

  const getRandomColor = () => {
    const colors = ["#1976d2", "#2e7d32", "#ed6c02", "#d32f2f", "#9c27b0", "#0288d1", "#388e3c", "#f57c00", "#c2185b", "#7b1fa2"];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  const fetchDashboardData = async (fastPasId = "") => {
    function formatDate(date) {
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
    }

    const todayDate = toDate
      ? new Date(toDate)
      : (() => {
          const d = new Date();
          d.setHours(0, 0, 0, 0);
          return d;
        })();

    const oneYearAgoDate = fromDate
      ? new Date(fromDate)
      : (() => {
          const d = new Date(todayDate);
          d.setFullYear(d.getFullYear() - 1);
          return d;
        })();

    const queryObj = {
      fromDateBi: formatDate(oneYearAgoDate),
      toDateBi: formatDate(todayDate),
      applicationType: selectedApplicationType === "ALL" ? "" : selectedApplicationType,
      district:
        selectedAuthority === "All" || selectedAuthority === "Uttar Pradesh Awas and Evam Vikas Parishad"
          ? ""
          : userDetails?.location1 || selectedAuthority?.split(" ")?.[0],
      department: tenantId === "up.avp" ? "AVP" : "DA",
      land_Id: fastPasId ? fastPasId : "",
    };

    Object.keys(queryObj).forEach((key) => {
      if (queryObj[key] === "") {
        delete queryObj[key];
      }
    });

    try {
      setLoading(true);
      const res = await Digit.OBPSService.dashboardReportData(tenantId, queryObj);
      const reportData = res?.CommonSearchRequest || [];
      setDashboardData(reportData);

      const departmentSet = new Set();
      const userSet = new Set();
      const applicationTypeSet = new Set();

      reportData.forEach((item) => {
        const assignee = item.createdUserName || "Unassigned";
        const formType = item.applicationType || "Unknown";
        const department = item.department || "Unknown";

        departmentSet.add(department);
        userSet.add(assignee);
        applicationTypeSet.add(formType);
      });

      setDepartments([...departmentSet]);
      setUsers([...userSet]);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching dashboard data", err);
      setDepartments(["Planning", "Construction", "Environment"]);
      setUsers(["User A", "User B", "User C"]);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (debounceFastPasIdSearch !== "") {
      fetchDashboardData(debounceFastPasIdSearch);
    } else fetchDashboardData();
  }, [debounceFastPasIdSearch]);

  const statusCounts = useMemo(() => {
    const statusMap = {
      total: dashboardData.length,
      approved: 0,
      inProgress: 0,
      draft: 0,
      shortfall: 0,
      rejected: 0,
      received: 0,
      provisionallyApproved: 0,
      dscPending: 0,
      selfApproval: 0,
      paymentPending: 0,
      autoRejected: 0,
    };

    dashboardData.forEach((item) => {
      const mainStatus = item.mainDashBoardStatus?.toLowerCase() || "unknown";
      const subStatus = item?.status?.toLowerCase() || "";
      const newSubStatus = item?.subDashBoardStatus?.toLowerCase(); 

      if ((mainStatus.includes("approved") || mainStatus.includes("approve")) && !subStatus.includes("apply for dsc")) {
        statusMap.approved += 1;
      }

      if (subStatus.includes("document uploaded")) {
        statusMap.draft += 1;
      }

      if (mainStatus.includes("in progress with officer")) {
        statusMap.inProgress += 1;
      }

      if (mainStatus === "self certification approved" || mainStatus === "self_certification_approved") {
        statusMap.selfApproval += 1;
      }

      if (subStatus.includes("make payment") || subStatus.includes("pay application fees") || subStatus.includes("make payment self")) {
        statusMap.paymentPending += 1;
      }

      if (subStatus.includes("reject") || mainStatus.includes("reject")) {
        statusMap.rejected += 1;
      }

      if (
        subStatus.includes("revert to applicant") ||
        subStatus.includes("send back to applicant") ||
        subStatus.includes("shortfall") ||
        mainStatus.includes("send back") ||
        mainStatus.includes("shortfall") ||
        mainStatus === "citizen_action_pending_at_ltp"
      ) {
        statusMap.shortfall += 1;
      }

      if (["received", "application received"].includes(mainStatus)) {
        statusMap.received += 1;
      }

      if (mainStatus.includes("provisionally approved")) {
        statusMap.provisionallyApproved += 1;
      }

      if (
        subStatus.includes("apply for dsc") ||
        subStatus.startsWith("apply_for_dsc") ||
        newSubStatus === "pending for dsc" ||
        mainStatus.startsWith("apply_for_dsc")
      ) {
        statusMap.dscPending += 1;
      }

      if (subStatus.includes("auto reject") || mainStatus.includes("auto reject")) {
        statusMap.autoRejected += 1;
      }
    });

    return statusMap;
  }, [dashboardData]);

  useEffect(() => {
    const riskMap = {};

    dashboardData.forEach((item) => {
      const riskType = item.riskType || "Not Specified";
      riskMap[riskType] = (riskMap[riskType] || 0) + 1;
    });

    if (selectedRisk) {
      let count = 0;
      if (selectedRisk === "low") {
        count = riskData.find((r) => r.riskType?.toLowerCase().includes("low"))?.count || 0;
      }
      if (selectedRisk === "medium") {
        count = riskData.find((r) => r.riskType?.toLowerCase().includes("medium"))?.count || 0;
      }
      if (selectedRisk === "high") {
        count = riskData.find((r) => r.riskType?.toLowerCase().includes("high"))?.count || 0;
      }
      const riskColorMap = {
        low: "#2e7d32",
        medium: "#ed6c02",
        high: "#d32f2f",
      };
      setFullData([
        {
          label: `${selectedRisk.toUpperCase()} Risk Applications`,
          count: count,
          color: riskColorMap[selectedRisk],
        },
      ]);
    } else {
      const barData = [
        { label: "Total Applications", count: statusCounts.total },
        { label: "Approved By Authority", count: statusCounts.approved },
        { label: "Self Certification Approved", count: statusCounts.selfApproval },
        { label: "In Progress With Officers", count: statusCounts.inProgress },
        { label: "Pending With Applicant", count: statusCounts.draft },
        { label: "Payment Pending", count: statusCounts.paymentPending },
        { label: "Rejected", count: statusCounts.rejected },
        { label: "Shortfall", count: statusCounts.shortfall },
      ].map((item) => ({
        ...item,
        color: getRandomColor(),
      }));
      setFullData(barData);
    }

    const processedRiskData = Object.entries(riskMap).map(([riskType, count]) => ({
      riskType,
      count,
      color: getRandomColor(),
    }));
    setRiskData(processedRiskData);
  }, [dashboardData, selectedRisk, filters.applicationType, statusCounts]);

  const handleCardClick = (cardType) => {
    if (cardType === "pendingWithOfficer") {
      setShowInProgressModal(true);
      return;
    }
    // else if (cardType === "Approved" && filters.applicationType === "FORM_LANDUSE") {
    //   setShowLandUseApprovedModal(true);
    //   return;
    // }

    if (activeCard === cardType) {
      setActiveCard(null);
      setFilters((prev) => ({
        ...prev,
        status: "",
        riskType: "",
      }));
      setSelectedRisk(null);
    } else {
      setActiveCard(cardType);
      setSelectedRisk(null);

      let statusFilter = "";
      switch (cardType) {
        case "Total Applications":
          statusFilter = "";
          break;
        case "Approved":
          statusFilter = "Approved";
          break;
        case "pendingWithApplicant":
          statusFilter = "Document Uploaded";
          break;
        case "Shortfall":
          statusFilter = "Send back to Applicant";
          break;
        case "Rejected":
          statusFilter = "Rejected";
          break;
        case "Received":
          statusFilter = "Received";
          break;
        case "ProvisionallyApproved":
          statusFilter = "Provisionally Approved";
          break;
        case "DSCPending":
          statusFilter = "Apply For DSC";
          break;
        case "SelfApproval":
          statusFilter = "Self Certification Approved";
          break;
        case "PaymentPending":
          statusFilter = "Make Payment";
          break;
        case "AutoRejected":
          statusFilter = "Auto Rejected";
          break;
        default:
          statusFilter = "";
      }

      setFilters((prev) => ({
        ...prev,
        status: statusFilter,
        riskType: "",
      }));
    }

    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  const handleRiskCardClick = (type) => {
    if (selectedRisk === type) {
      setSelectedRisk(null);
      setFilters((prev) => ({
        ...prev,
        riskType: "",
      }));
    } else {
      setSelectedRisk(type);
      let riskValue = "";
      if (type === "low") riskValue = "LOW";
      if (type === "medium") riskValue = "MEDIUM";
      if (type === "high") riskValue = "HIGH";
      setFilters((prev) => ({
        ...prev,
        riskType: riskValue,
      }));
    }
  };

  const filteredApplications = dashboardData.filter((app) => {
    const matchesSearch =
      !searchQuery ||
      (app.applicationType && app.applicationType.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (app.applicationNo && app.applicationNo.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (app.createdUserName && app.createdUserName.toLowerCase().includes(searchQuery.toLowerCase()));

      const status = app.status?.toString().toLowerCase() || "";
      const mainStatus = app.mainDashBoardStatus?.toString().toLowerCase() || "";
      const newSubStatus = app?.subDashBoardStatus?.toLowerCase(); 
      
      const filterStatus = filters.status?.toString() || "";
      
      let matchesStatus = !filterStatus ? true : false;

    if (filterStatus) {
      if (filterStatus === "Rejected") {
        matchesStatus = status.includes("reject") || mainStatus.includes("reject");
      } else if (filterStatus === "Send back to Applicant") {
        matchesStatus =
          status.includes("revert to applicant") ||
          status.includes("send back to applicant") ||
          status.includes("shortfall") ||
          mainStatus.includes("send back") ||
          mainStatus.includes("shortfall") ||
          mainStatus === "citizen_action_pending_at_ltp";
      } else if (filterStatus === "Document Uploaded") {
        matchesStatus = status.includes("document uploaded");
      } else if (filterStatus === "Approved") {
        matchesStatus =
          (mainStatus.includes("approved") || mainStatus.includes("approve")) &&
          !status.includes("apply for dsc");
      } else if (filterStatus === "Make Payment") {
        matchesStatus =
          status.includes("make payment") ||
          status.includes("pay application fees") ||
          status.includes("make payment self");
      } else if (filterStatus === "Apply For DSC") {
        matchesStatus = status.includes("apply for dsc") || status.startsWith("APPLY_FOR_DSC") || newSubStatus === "pending for dsc" || mainStatus.startsWith("APPLY_FOR_DSC");
      } else if (filterStatus === "Self Certification Approved") {
        matchesStatus =
          mainStatus === "self certification approved" || mainStatus === "self_certification_approved";
      } else if (filterStatus === "Provisionally Approved") {
        matchesStatus = mainStatus.includes("provisionally approved");
      } else if (filterStatus === "Received") {
        matchesStatus = mainStatus === "received" || mainStatus === "application received";
      } else if (filterStatus === "Auto Rejected") {
        matchesStatus = status.includes("auto reject") || mainStatus.includes("auto reject");
      } else {
        matchesStatus = app.mainDashBoardStatus === filterStatus;
      }
    }

    return (
      matchesSearch &&
      matchesStatus &&
      (!filters.riskType || app.riskType === filters.riskType || (filters.riskType === "HIGH" && app.riskType === "HIGH_NIVESH")) &&
      (!filters.applicationType || app.applicationType === filters.applicationType) &&
      (!filters.createdBy || app.createdUserName === filters.createdBy) &&
      (!filters.department || app.department === filters.department)
    );
  });

  const handleChange = (key) => (event) => {
    const value = event.target.value;
    const filterValue = key === "applicationType" && value === "ALL" ? "" : value;
    setFilters((prev) => ({ ...prev, [key]: filterValue }));

    if (key === "status") {
      setSelectedStatus(value);
      if (value === "") {
        setActiveCard(null);
      }
    }
    if (key === "authority") setSelectedAuthority(value);
    if (key === "applicationType") setSelectedApplicationType(value);
    if (key === "createdBy") setSelectedUser(value);
  };

  const getCardData = () => {
    const total = statusCounts.total;
    const approved = statusCounts.approved;
    const inProgress = statusCounts.inProgress;
    const draft = statusCounts.draft;
    const shortfall = statusCounts.shortfall;
    const rejected = statusCounts.rejected;
    const received = statusCounts.received;
    const provisionallyApproved = statusCounts.provisionallyApproved;
    const dscPending = statusCounts.dscPending;
    const selfApproval = statusCounts.selfApproval;
    const paymentPending = statusCounts.paymentPending;
    const autoRejected = statusCounts.autoRejected;

    const applicationTypeText = filters.applicationType ? `${filters.applicationType} applications` : "All applications";

    return [
      {
        title: "Total Applications",
        value: total.toLocaleString(),
        subtitle: applicationTypeText,
        color: "#1976d2",
        icon: "📊",
        type: "Total Applications",
        isActive: activeCard === "Total Applications",
      },
      {
        title: "Approved",
        value: approved.toLocaleString(),
        subtitle: "Approved by authority",
        color: "#4CAF50",
        icon: "✅",
        type: "Approved",
        isActive: activeCard === "Approved",
      },
      {
        title: "In Progress with Officer",
        value: inProgress.toLocaleString(),
        subtitle: "",
        color: "#4CAF50",
        icon: "⏳",
        type: "pendingWithOfficer",
        isActive: activeCard === "pendingWithOfficer",
      },
      {
        title: "Draft Files",
        value: draft.toLocaleString(),
        subtitle: "With Applicant",
        color: "#FF9800",
        icon: "✍️",
        type: "pendingWithApplicant",
        isActive: activeCard === "pendingWithApplicant",
      },
      {
        title: "Shortfall",
        value: shortfall.toLocaleString(),
        subtitle: "Documents required",
        color: "#9C27B0",
        icon: "⏳",
        type: "Shortfall",
        isActive: activeCard === "Shortfall",
      },
      {
        title: "Rejected",
        value: rejected.toLocaleString(),
        subtitle: "",
        color: "#F44336",
        icon: "❌",
        type: "Rejected",
        isActive: activeCard === "Rejected",
      },
      {
        title: "Received",
        value: received.toLocaleString(),
        subtitle: "Newly submitted",
        color: "#009688",
        icon: "📥",
        type: "Received",
        isActive: activeCard === "Received",
      },
      {
        title: "Provisionally Approved",
        value: provisionallyApproved.toLocaleString(),
        subtitle: "",
        color: "#8BC34A",
        icon: "📋",
        type: "ProvisionallyApproved",
        isActive: activeCard === "ProvisionallyApproved",
      },
      {
        title: "DSC Pending",
        value: dscPending.toLocaleString(),
        subtitle: "",
        color: "#455a64",
        icon: "🔐",
        type: "DSCPending",
        isActive: activeCard === "DSCPending",
      },
      {
        title: "Self Approval",
        value: selfApproval.toLocaleString(),
        subtitle: "Self certified",
        color: "#FF7043",
        icon: "✅",
        type: "SelfApproval",
        isActive: activeCard === "SelfApproval",
      },
      {
        title: "Payment Pending",
        value: paymentPending.toLocaleString(),
        subtitle: "Fees due",
        color: "#f57c00",
        icon: "💳",
        type: "PaymentPending",
        isActive: activeCard === "PaymentPending",
      },
      {
        title: "Auto Rejected",
        value: autoRejected.toLocaleString(),
        subtitle: "System rejected",
        color: "#8e24aa",
        icon: "❌",
        type: "AutoRejected",
        isActive: activeCard === "AutoRejected",
      },
    ];
  };

  const cardData = getCardData();

  const getAdditionalCards = () => {
    const lowRisk = riskData.find((r) => r.riskType?.toLowerCase().includes("low"))?.count || 0;
    const mediumRisk = riskData.find((r) => r.riskType?.toLowerCase().includes("medium"))?.count || 0;
    const highRisk = riskData.find((r) => r.riskType?.toLowerCase().includes("high"))?.count || 0;
    const highNivesh = riskData.find((r) => r.riskType?.toLowerCase().includes("nivesh"))?.count || 0;

    return [
      { title: "Low Risk Applications", value: lowRisk.toLocaleString(), color: "#2e7d32", icon: "🟢" },
      { title: "Medium Risk Applications", value: mediumRisk.toLocaleString(), color: "#ed6c02", icon: "🟠" },
      { title: "High Risk Applications", value: highRisk.toLocaleString(), color: "#d32f2f", icon: "🔴" },
      // { title: "HIGH Nivesh", value: highNivesh.toLocaleString(), color: "#6a1b9a", icon: "🏗️" },
    ];
  };

  const additionalCards = getAdditionalCards();

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : false);
  };

  const KpiCard = ({ card }) => {
    const handleClick = () => {
      if (card.title === "Low Risk Applications") handleRiskCardClick("low");
      else if (card.title === "Medium Risk Applications") handleRiskCardClick("medium");
      else if (card.title === "High Risk Applications") handleRiskCardClick("high");
    };

    const isActive =
      (selectedRisk === "low" && card.title === "Low Risk Applications") ||
      (selectedRisk === "medium" && card.title === "Medium Risk Applications") ||
      (selectedRisk === "high" && card.title === "High Risk Applications");

    return (
      <Card
        onClick={handleClick}
        sx={{
          borderRadius: "16px",
          border: isActive ? `2px solid ${card.color}` : "1px solid rgba(255,255,255,0.3)",
          boxShadow: isActive ? `0 8px 24px ${card.color}50` : "0 4px 16px rgba(0,0,0,0.10)",
          height: "90px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2.5,
          cursor: "pointer",
          transition: "all 0.3s cubic-bezier(.4,0,.2,1)",
          background: isActive
            ? `linear-gradient(135deg, ${card.color}22 0%, ${card.color}08 100%)`
            : "linear-gradient(135deg, #ffffff 0%, #f4f6fb 100%)",
          "&:hover": {
            boxShadow: `0 10px 28px ${card.color}40`,
            transform: "translateY(-3px) scale(1.02)",
          },
          position: "relative",
          overflow: "hidden",
        }}
      >
        {isActive && <Box sx={{ position: "absolute", top: 0, left: 0, right: 0, height: "3px", background: `linear-gradient(90deg, ${card.color}, ${card.color}88)` }} />}
        <Box>
          <Typography sx={{ fontSize: "11px", fontWeight: 700, color: "#888", textTransform: "uppercase", letterSpacing: "0.6px" }}>
            {card.title}
          </Typography>
          <Typography sx={{ fontSize: "22px", fontWeight: 800, color: card.color, mt: 0.3, lineHeight: 1 }}>
            {card.value}
          </Typography>
        </Box>
        <Box sx={{ background: `linear-gradient(135deg, ${card.color}30, ${card.color}15)`, borderRadius: "12px", width: 42, height: 42, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px", boxShadow: `0 2px 8px ${card.color}30` }}>
          {card.icon}
        </Box>
      </Card>
    );
  };

  const MainTile = ({ card }) => (
    <Card
      onClick={() => handleCardClick(card.type)}
      sx={{
        borderRadius: "16px",
        border: card.isActive ? `2px solid ${card.color}` : "1px solid rgba(0,0,0,0.06)",
        boxShadow: card.isActive
          ? `0 8px 32px ${card.color}45`
          : "0 2px 12px rgba(0,0,0,0.07)",
        transition: "all 0.3s cubic-bezier(.4,0,.2,1)",
        "&:hover": {
          boxShadow: `0 12px 32px ${card.color}35`,
          transform: "translateY(-4px) scale(1.01)",
          cursor: "pointer",
        },
        height: "100%",
        minHeight: "110px",
        background: card.isActive
          ? `linear-gradient(140deg, ${card.color}18 0%, ${card.color}06 100%)`
          : "linear-gradient(140deg, #ffffff 0%, #f7f9fc 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box sx={{
        position: "absolute", top: 0, left: 0, right: 0, height: "3px",
        background: card.isActive
          ? `linear-gradient(90deg, ${card.color}, ${card.color}66)`
          : `linear-gradient(90deg, ${card.color}55, ${card.color}11)`,
        transition: "all 0.3s ease",
      }} />

      <Box sx={{
        position: "absolute", bottom: -18, right: -18,
        width: 72, height: 72, borderRadius: "50%",
        background: `radial-gradient(circle, ${card.color}18, transparent 70%)`,
        transition: "all 0.3s ease",
      }} />

      <CardContent sx={{ p: "14px 16px !important", position: "relative", zIndex: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
          <Box sx={{
            background: `linear-gradient(135deg, ${card.color}28, ${card.color}10)`,
            borderRadius: "10px", width: 36, height: 36,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: "16px", boxShadow: `0 2px 6px ${card.color}25`,
          }}>
            {card.icon}
          </Box>
          {card.isActive && (
            <Box sx={{
              width: 8, height: 8, borderRadius: "50%", backgroundColor: card.color,
              boxShadow: `0 0 0 3px ${card.color}30`,
              animation: "pulse 1.5s infinite",
              "@keyframes pulse": {
                "0%": { boxShadow: `0 0 0 0 ${card.color}50` },
                "70%": { boxShadow: `0 0 0 6px ${card.color}00` },
                "100%": { boxShadow: `0 0 0 0 ${card.color}00` },
              },
            }} />
          )}
        </Box>

        <Typography sx={{ fontWeight: 800, color: card.color, fontSize: "26px", lineHeight: 1, mb: 0.4, letterSpacing: "-0.5px" }}>
          {card.value}
        </Typography>

        <Typography sx={{ color: "#555", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", lineHeight: 1.3 }}>
          {card.title}
        </Typography>

        {card.subtitle && (
          <Typography sx={{ color: "#aaa", fontSize: "9.5px", fontWeight: 500, mt: 0.3 }}>
            {card.subtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );

  const filterFieldSx = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      background: "rgba(255,255,255,0.95)",
      "& fieldset": {
        borderColor: "rgba(255,255,255,0.5)",
        borderWidth: "1px",
      },
      "&:hover fieldset": { borderColor: "rgba(255,255,255,0.8)" },
      "&.Mui-focused fieldset": { borderColor: "#fff" },
    },
  };
  const filterLabelSx = {
    color: "#1565c0",
    fontWeight: 700,
    fontSize: "12px",
    backgroundColor: "rgba(255,255,255,0.95)",
    px: 0.5,
    borderRadius: "4px",
    transform: "translate(14px, -9px) scale(0.85)",
    "&.Mui-focused": { color: "#1565c0" },
  };
  const filterSelectSx = {
    borderRadius: "10px",
    background: "rgba(255,255,255,0.95)",
    color: "#222",
    fontSize: "13px",
    fontWeight: 500,
  };
  const datePickerSx = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      background: "rgba(255,255,255,0.95)",
      fontSize: "13px",
      "& fieldset": {
        borderColor: "rgba(255,255,255,0.5)",
        borderWidth: "1px",
      },
      "&:hover fieldset": { borderColor: "rgba(255,255,255,0.8)" },
      "&.Mui-focused fieldset": { borderColor: "#fff" },
    },
    "& .MuiInputLabel-root": {
      color: "#1565c0",
      fontWeight: 700,
      fontSize: "12px",
      backgroundColor: "rgba(255,255,255,0.95)",
      px: 0.5,
      borderRadius: "4px",
      transform: "translate(14px, -9px) scale(0.85)",
      "&.MuiInputLabel-shrink": { transform: "translate(14px, -9px) scale(0.85)" },
    },
  };

  // ── Stable Memoized Props for Sub-Components ───────────────────────────
  const computedLocation = useMemo(() => {
    return location1?.split(" ")[0] || selectedAuthority?.split(" ")[0];
  }, [location1, selectedAuthority]);

  const computedDepartment = useMemo(() => {
    return selectedAuthority === "Uttar Pradesh Awas and Evam Vikas Parishad" ? "AVP" : "DA";
  }, [selectedAuthority]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ background: "linear-gradient(160deg, #f0f4ff 0%, #fafbff 50%, #f5f0ff 100%)", minHeight: "100vh", p: 0 }}>

        <Box sx={{
          background: "linear-gradient(135deg, #0d2b6b 0%, #1565c0 28%, #1976d2 52%, #0288d1 76%, #006064 100%)",
          px: 4, pt: 3, pb: 0,
          position: "relative", overflow: "hidden",
        }}>

          <Box sx={{ position: "absolute", top: -80, right: -80, width: 300, height: 300, borderRadius: "50%", background: "radial-gradient(circle, rgba(255,255,255,0.09) 0%, transparent 70%)", pointerEvents: "none" }} />
          <Box sx={{ position: "absolute", bottom: -100, left: "-5%", width: 340, height: 340, borderRadius: "50%", background: "radial-gradient(circle, rgba(255,255,255,0.07) 0%, transparent 70%)", pointerEvents: "none" }} />
          <Box sx={{ position: "absolute", top: "20%", left: "45%", width: 180, height: 180, borderRadius: "50%", background: "radial-gradient(circle, rgba(0,200,255,0.08) 0%, transparent 70%)", pointerEvents: "none" }} />

          <Box sx={{
            position: "absolute", top: -30, right: "12%", width: 120, height: 120,
            border: "1.5px solid rgba(255,255,255,0.12)", borderRadius: "50%",
            animation: "spin 18s linear infinite",
            "@keyframes spin": { from: { transform: "rotate(0deg)" }, to: { transform: "rotate(360deg)" } },
            pointerEvents: "none",
          }} />
          <Box sx={{
            position: "absolute", top: 10, right: "calc(12% + 20px)", width: 80, height: 80,
            border: "1px solid rgba(255,255,255,0.08)", borderRadius: "50%",
            animation: "spin 12s linear infinite reverse",
            "@keyframes spin": { from: { transform: "rotate(0deg)" }, to: { transform: "rotate(360deg)" } },
            pointerEvents: "none",
          }} />

          <Box sx={{
            position: "absolute", top: 0, left: 0, right: 0, height: "100%",
            backgroundImage: "radial-gradient(rgba(255,255,255,0.04) 1px, transparent 1px)",
            backgroundSize: "28px 28px",
            pointerEvents: "none",
          }} />

          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2.5, position: "relative", zIndex: 2 }}>

            <Box sx={{ textAlign: "center", flex: 1, px: 2 }}>
              <Box sx={{
                display: "inline-flex", alignItems: "center", gap: 0.7,
                background: "linear-gradient(90deg, rgba(255,255,255,0.12), rgba(255,255,255,0.08))",
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: "20px", px: 1.5, py: 0.3, mb: 0.8,
              }}>
                <Box sx={{ width: 6, height: 6, borderRadius: "50%", background: "#4cff91", boxShadow: "0 0 6px #4cff91" }} />
                <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "rgba(255,255,255,0.85)", letterSpacing: "1.5px", textTransform: "uppercase" }}>
                  Live Dashboard
                </Typography>
              </Box>

              <Typography sx={{
                fontWeight: 900, fontSize: "32px", color: "#fff",
                letterSpacing: "-0.5px", lineHeight: 1,
                textShadow: "0 2px 20px rgba(0,0,0,0.3)",
              }}>
                FASTPAS
                <Box component="span" sx={{
                  ml: 1.5, fontSize: "28px", fontWeight: 400, color: "rgba(255,255,255,0.55)",
                }}>
                  Dashboard
                </Box>
              </Typography>

              <Box sx={{
                mx: "auto", mt: 0.8, mb: 0.6,
                width: "50%", height: "2px", borderRadius: "2px",
                background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.7), rgba(100,220,255,0.9), rgba(255,255,255,0.7), transparent)",
              }} />

              <Typography sx={{ fontSize: "12px", color: "rgba(255,255,255,0.6)", fontWeight: 500, letterSpacing: "0.3px" }}>
                Fast &amp; Simplified Trust based Plan Approval System
              </Typography>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 1, flexShrink: 0 }}>
              <Box sx={{
                background: "linear-gradient(135deg, rgba(255,255,255,0.15), rgba(255,255,255,0.06))",
                backdropFilter: "blur(12px)", borderRadius: "12px",
                px: 2, py: 0.8, border: "1px solid rgba(255,255,255,0.2)",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              }}>
                <Typography sx={{ color: "#fff", fontSize: "12px", fontWeight: 600, textAlign: "right" }}>
                  📅 {new Date().toLocaleDateString("en-IN", { weekday: "short", day: "2-digit", month: "short", year: "numeric" })}
                </Typography>
              </Box>
              <Box sx={{
                background: loading
                  ? "linear-gradient(135deg, rgba(255,200,0,0.2), rgba(255,150,0,0.1))"
                  : "linear-gradient(135deg, rgba(76,255,145,0.2), rgba(0,200,100,0.1))",
                backdropFilter: "blur(8px)", borderRadius: "10px",
                px: 1.5, py: 0.6, border: `1px solid ${loading ? "rgba(255,200,0,0.3)" : "rgba(76,255,145,0.3)"}`,
                display: "flex", alignItems: "center", gap: 0.7,
              }}>
                <Box sx={{
                  width: 7, height: 7, borderRadius: "50%",
                  background: loading ? "#ffc107" : "#4cff91",
                  boxShadow: loading ? "0 0 6px #ffc107" : "0 0 6px #4cff91",
                  animation: "pulse 1.8s infinite",
                  "@keyframes pulse": { "0%,100%": { opacity: 1 }, "50%": { opacity: 0.4 } },
                }} />
                <Typography sx={{ fontSize: "11px", fontWeight: 700, color: loading ? "#ffc107" : "#4cff91" }}>
                  {loading ? "Refreshing…" : "Live Data"}
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box sx={{
            background: "rgba(255,255,255,0.10)",
            backdropFilter: "blur(16px)",
            border: "1px solid rgba(255,255,255,0.18)",
            borderRadius: "18px 18px 0 0",
            px: 3, pt: 2.5, pb: 2,
            position: "relative", zIndex: 2,
          }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={3}>
                <FormControl fullWidth size="small" sx={filterFieldSx}>
                  <InputLabel shrink sx={filterLabelSx}>Authority</InputLabel>
                  <Select value={selectedAuthority || location1 || ""} onChange={handleChange("authority")} label="Authority" disabled={!isSuperAdmin} notched sx={filterSelectSx}>
                    {DashboardAuthorityList?.map((item) => (
                      <MenuItem key={item.code} value={item.label}>{item.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <Stack direction="row" spacing={1}>
                  <DatePicker
                    label="From Date"
                    value={fromDate}
                    maxDate={toDate}
                    onChange={(newDate) => {
                      if (!newDate) return;
                      setFromDate(newDate);
                      if (toDate > addOneYear(newDate)) {
                        setToDate(addOneYear(newDate));
                      }
                    }}
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                        InputLabelProps: { shrink: true },
                        sx: datePickerSx,
                      },
                    }}
                  />

                  <DatePicker
                    label="To Date"
                    value={toDate}
                    minDate={fromDate}
                    maxDate={addOneYear(fromDate)}
                    onChange={(newDate) => {
                      if (!newDate) return;
                      setToDate(newDate);
                    }}
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                        InputLabelProps: { shrink: true },
                        sx: datePickerSx,
                      },
                    }}
                  />
                </Stack>
              </Grid>

              <Grid item xs={12} md={3}>
                <FormControl fullWidth size="small" sx={filterFieldSx}>
                  <InputLabel shrink sx={filterLabelSx}>Application Type</InputLabel>
                  <Select value={selectedApplicationType || ""} onChange={handleChange("applicationType")} label="Application Type" notched sx={filterSelectSx}>
                    {applicationTypes.map((item) => (
                      <MenuItem key={item.code} value={item.code}>{item.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={2}>
                <Button
                  variant="contained"
                  disabled={loading}
                  fullWidth
                  onClick={() => fetchDashboardData("")}
                  sx={{
                    height: "40px", borderRadius: "10px", fontWeight: 800,
                    background: "linear-gradient(135deg, #ffffff 0%, #e3f2fd 100%)",
                    color: "#0d2b6b",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.25), 0 1px 0 rgba(255,255,255,0.6) inset",
                    "&:hover": {
                      background: "linear-gradient(135deg, #ffffff 0%, #bbdefb 100%)",
                      boxShadow: "0 6px 24px rgba(0,0,0,0.3)",
                      transform: "translateY(-1px)",
                    },
                    transition: "all 0.2s ease",
                    textTransform: "none", fontSize: "14px",
                    letterSpacing: "0.3px",
                  }}
                >
                  {loading
                    ? <CircularProgress size={20} sx={{ color: "#0d2b6b" }} />
                    : <React.Fragment><SearchIcon sx={{ fontSize: 17, mr: 0.5 }} />Search</React.Fragment>}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box sx={{ px: 3, pt: 3, pb: 4 }}>

          {activeCard && (
            <Box sx={{
              display: "inline-flex", alignItems: "center", gap: 1,
              background: "linear-gradient(135deg, #e8f4fd, #f0e6ff)", borderRadius: "20px",
              px: 2, py: 0.6, mb: 2, border: "1px solid rgba(25,118,210,0.2)",
              boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            }}>
              <Box sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "#1976d2" }} />
              <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#1565c0" }}>
                Filtered: {activeCard}
              </Typography>
              <Box
                onClick={() => { setActiveCard(null); setFilters(f => ({ ...f, status: "", riskType: "" })); setSelectedRisk(null); }}
                sx={{ ml: 0.5, cursor: "pointer", color: "#888", fontSize: "14px", fontWeight: 700, lineHeight: 1, "&:hover": { color: "#d32f2f" } }}
              >
                ×
              </Box>
            </Box>
          )}

          <Box sx={{ display: "flex", alignItems: "center", mb: 1.5, gap: 1 }}>
            <Box sx={{ width: 4, height: 20, borderRadius: "2px", background: "linear-gradient(180deg,#1976d2,#0288d1)" }} />
            <Typography sx={{ fontWeight: 700, fontSize: "13px", color: "#444", textTransform: "uppercase", letterSpacing: "1px" }}>
              Application Overview
            </Typography>
          </Box>

          <Grid container spacing={2} sx={{ mb: 1.5 }}>
            {cardData.slice(0, 6).map((card, index) => (
              <Grid item xs={12} sm={6} md={2} key={index}>
                <MainTile card={card} />
              </Grid>
            ))}
          </Grid>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            {cardData.slice(6, 12).map((card, index) => (
              <Grid item xs={12} sm={6} md={2} key={index}>
                <MainTile card={card} />
              </Grid>
            ))}
          </Grid>

          <Box sx={{ display: "flex", alignItems: "center", mb: 1.5, gap: 1 }}>
            <Box sx={{ width: 4, height: 20, borderRadius: "2px", background: "linear-gradient(180deg,#d32f2f,#ed6c02)" }} />
            <Typography sx={{ fontWeight: 700, fontSize: "13px", color: "#444", textTransform: "uppercase", letterSpacing: "1px" }}>
              Risk Intelligence
            </Typography>
          </Box>

          <Grid container spacing={3} sx={{ mb: 3 }}>
            <Grid item xs={12} md={9}>
              <Grid container spacing={2} sx={{ mb: 2 }}>
                {additionalCards.map((card, index) => (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                    <KpiCard card={card} />
                  </Grid>
                ))}
              </Grid>

              <Accordion
                expanded={expandedAccordion === "chartPanel"}
                onChange={handleAccordionChange("chartPanel")}
                sx={{
                  borderRadius: "16px !important", border: "1px solid rgba(25,118,210,0.15)",
                  boxShadow: "0 4px 20px rgba(25,118,210,0.08)",
                  background: "linear-gradient(135deg, #ffffff 0%, #f7faff 100%)",
                  "&:before": { display: "none" },
                  overflow: "hidden",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#1976d2" }} />}
                  sx={{ background: "linear-gradient(135deg, #e8f4fd 0%, #f0f7ff 100%)", borderBottom: "1px solid rgba(25,118,210,0.1)", minHeight: 56 }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box sx={{ fontSize: "20px" }}>📊</Box>
                    <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "#1565c0" }}>
                      Application Status Chart
                    </Typography>
                    {fullData.length > 0 && (
                      <Box sx={{ ml: 1, background: "#1976d2", color: "#fff", borderRadius: "10px", px: 1, py: 0.1, fontSize: "11px", fontWeight: 700 }}>
                        {fullData.length} categories
                      </Box>
                    )}
                  </Box>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 2 }}>
                  <BarChartPage data={fullData} />
                </AccordionDetails>
              </Accordion>
            </Grid>

            <Grid item xs={12} md={3}>
              <Box sx={{
                borderRadius: "16px", border: "1px solid rgba(25,118,210,0.12)",
                background: "linear-gradient(160deg, #ffffff 0%, #f0f7ff 100%)",
                boxShadow: "0 4px 20px rgba(25,118,210,0.07)",
                p: 2.5, height: "100%",
              }}>
                <Typography sx={{ fontWeight: 700, fontSize: "13px", color: "#1565c0", mb: 2, textTransform: "uppercase", letterSpacing: "0.8px" }}>
                  📈 Quick Stats
                </Typography>
                {[
                  { label: "Total", value: cardData[0]?.value, color: "#1976d2" },
                  { label: "Approved", value: cardData[1]?.value, color: "#4CAF50" },
                  { label: "Rejected", value: cardData[5]?.value, color: "#F44336" },
                  { label: "Pending", value: cardData[3]?.value, color: "#FF9800" },
                ].map((s, i) => (
                  <Box key={i} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", py: 1.2, borderBottom: i < 3 ? "1px solid rgba(0,0,0,0.05)" : "none" }}>
                    <Typography sx={{ fontSize: "12px", color: "#666", fontWeight: 600 }}>{s.label}</Typography>
                    <Typography sx={{ fontSize: "18px", fontWeight: 800, color: s.color }}>{s.value || "0"}</Typography>
                  </Box>
                ))}
                {loading && (
                  <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                    <CircularProgress size={24} sx={{ color: "#1976d2" }} />
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>

          <Box sx={{ display: "flex", alignItems: "center", mb: 1.5, gap: 1 }}>
            <Box sx={{ width: 4, height: 20, borderRadius: "2px", background: "linear-gradient(180deg,#7b1fa2,#c2185b)" }} />
            <Typography sx={{ fontWeight: 700, fontSize: "13px", color: "#444", textTransform: "uppercase", letterSpacing: "1px" }}>
              Applications
            </Typography>
          </Box>

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box sx={{ borderRadius: "16px", overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,0.07)", border: "1px solid rgba(0,0,0,0.06)" }}>
                <ProgreesWithOfficer
                  tenantId={tenantId}
                  userDetails={userDetails}
                  location={computedLocation}
                  department={computedDepartment}
                  onApplicationSelect={setSelectedApplication}
                  dashboardData={dashboardData}
                  fromDate={fromDate}
                  toDate={toDate}
                  selectedApplicationType={selectedApplicationType}
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ borderRadius: "16px", overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,0.07)", border: "1px solid rgba(0,0,0,0.06)" }}>
                <ApplicationTable
                  dashboardData={dashboardData}
                  filters={filters}
                  fastPasIdSearch={fastPasIdSearch}
                  setFastPasIdSearch={setFastPasIdSearch}
                  loading={loading}
                  showMs={showMs}
                  setshowMs={setshowMs}
                  onApplicationSelect={setSelectedApplication}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>

        {selectedApplication && (
          <DialogContentModal
            dataOpen={!!selectedApplication}
            onClose={() => setSelectedApplication(null)}
            title={`Application Details - ${selectedApplication?.applicationNo}`}
          >
            <EmployeeApplicationDetail isFromDashboard={true} />
          </DialogContentModal>
        )}
        {showInProgressModal && (
          <DialogContentModal
            dataOpen={showInProgressModal}
            onClose={() => setShowInProgressModal(false)}
            title="In Progress With Officer — Status Summary"
          >
            <InProgressWithOfficerModal dashboardData={dashboardData} onApplicationSelect={setSelectedApplication} />
          </DialogContentModal>
        )}
        {
          showLandUseApprovedModal && <DialogContentModal
            dataOpen={showLandUseApprovedModal}
            onClose={() => setShowLandUseApprovedModal(false)}
            title="Land Use Approved — Status Summary"
          >
            <LandUseApprovedSummary dashboardData={dashboardData} onApplicationSelect={setSelectedApplication} />
          </DialogContentModal>
        }
      </Box>
    </LocalizationProvider>
  );
};

export default DashboardPage;